import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const dateFormats: Record<string, string> = {
	'us-long': 'MM/DD/YYYY',
	'us-short': 'MM/DD/YY',
	'eu-long': 'DD/MM/YYYY',
	'eu-short': 'DD/MM/YY'
};

export function userDatePattern(format?: string | null): string {
	return dateFormats[format ?? 'us-long'] ?? 'MM/DD/YYYY';
}

export function parseUserDate(value: string | number | Date | null | undefined, dateFormat?: string | null) {
	if (value == null || value === '') return dayjs(null);
	// Match DTOs append the weekday when enabled. It is presentation, not part of
	// the date used for filtering, calendar grouping, sorting, or editing.
	const raw = typeof value === 'string' ? value.trim().replace(/,\s*(Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday)$/i, '').trim() : value;
	if (typeof raw === 'string' && /^\d{1,2}\/\d{1,2}\/\d{2,4}$/.test(raw)) {
		const format = userDatePattern(dateFormat);
		const formats = format.startsWith('DD') ? ['DD/MM/YYYY', 'DD/MM/YY', 'D/M/YYYY', 'D/M/YY'] : ['MM/DD/YYYY', 'MM/DD/YY', 'M/D/YYYY', 'M/D/YY'];
		const parsed = dayjs(raw, formats, true);
		// Before preferences load, an unambiguous date can still identify its order.
		if (parsed.isValid()) return parsed;
		const alternativeFormats = format.startsWith('DD') ? ['MM/DD/YYYY', 'MM/DD/YY', 'M/D/YYYY', 'M/D/YY'] : ['DD/MM/YYYY', 'DD/MM/YY', 'D/M/YYYY', 'D/M/YY'];
		return dayjs(raw, alternativeFormats, true);
	}
	return dayjs(raw);
}
